function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBaasIconBlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1.9469 4.25984L1.94691 4.25985L1.94818 4.25934L8.69606 1.56019C8.69635 1.56008 8.69665 1.55997 8.69694 1.55985C8.86376 1.49438 9.13621 1.49437 9.30304 1.55984C9.30334 1.55996 9.30364 1.56008 9.30394 1.56019L16.0518 4.25934L16.0531 4.25984C16.3339 4.37128 16.5625 4.71126 16.5625 5.0101V7.5001C16.5625 7.94396 16.1939 8.3126 15.75 8.3126H2.25C1.80614 8.3126 1.4375 7.94396 1.4375 7.5001V5.0101C1.4375 4.70538 1.6646 4.37187 1.9469 4.25984ZM1.99661 4.37344L1.97739 4.38114L1.95887 4.3904C1.82649 4.45659 1.73868 4.56668 1.70026 4.61988C1.67365 4.65673 1.64468 4.70282 1.62037 4.75586C1.60024 4.79979 1.5625 4.89236 1.5625 5.0101V7.5001C1.5625 7.88124 1.86886 8.1876 2.25 8.1876H15.75C16.1311 8.1876 16.4375 7.88124 16.4375 7.5001V5.0101C16.4375 4.90203 16.4061 4.81536 16.3865 4.76916C16.3638 4.71554 16.3358 4.66767 16.3079 4.62742C16.2666 4.56796 16.1704 4.44486 16.0145 4.37804L16.0145 4.3779L16.0032 4.37337L9.26126 1.67656C9.18128 1.6425 9.11119 1.63526 9.08047 1.63273C9.0472 1.62999 9.01402 1.63008 9.00251 1.63012C9.0015 1.63012 9.00066 1.63012 9 1.63012L8.99731 1.63012C8.98481 1.6301 8.9533 1.63004 8.92161 1.63228C8.92101 1.63233 8.92033 1.63237 8.91956 1.63243C8.89902 1.63383 8.8209 1.63915 8.73345 1.67569L1.99661 4.37344Z",
    fill: "black",
    stroke: "black",
    style: {
      fill: "black",
      fillOpacity: 1,
      stroke: "black",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5625 15.9375V16.4375H2.0625H15.9375H16.4375V15.9375V14.25C16.4375 13.8689 16.1311 13.5625 15.75 13.5625H2.25C1.86886 13.5625 1.5625 13.8689 1.5625 14.25V15.9375ZM16.5 16.5625H1.5C1.48694 16.5625 1.47128 16.5573 1.45699 16.543C1.4427 16.5287 1.4375 16.5131 1.4375 16.5V14.25C1.4375 13.8061 1.80614 13.4375 2.25 13.4375H15.75C16.1939 13.4375 16.5625 13.8061 16.5625 14.25V16.5C16.5625 16.5131 16.5573 16.5287 16.543 16.543C16.5287 16.5573 16.5131 16.5625 16.5 16.5625Z",
    fill: "black",
    stroke: "black",
    style: {
      fill: "black",
      fillOpacity: 1,
      stroke: "black",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 13.5625C2.98694 13.5625 2.97128 13.5573 2.95699 13.543C2.9427 13.5287 2.9375 13.5131 2.9375 13.5V8.25C2.9375 8.23694 2.9427 8.22128 2.95699 8.20699C2.97128 8.1927 2.98694 8.1875 3 8.1875C3.01306 8.1875 3.02872 8.1927 3.04301 8.20699C3.0573 8.22128 3.0625 8.23694 3.0625 8.25V13.5C3.0625 13.5131 3.0573 13.5287 3.04301 13.543C3.02872 13.5573 3.01306 13.5625 3 13.5625Z",
    fill: "black",
    stroke: "black",
    style: {
      fill: "black",
      fillOpacity: 1,
      stroke: "black",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 13.5625C5.98694 13.5625 5.97128 13.5573 5.95699 13.543C5.9427 13.5287 5.9375 13.5131 5.9375 13.5V8.25C5.9375 8.23694 5.9427 8.22128 5.95699 8.20699C5.97128 8.1927 5.98694 8.1875 6 8.1875C6.01306 8.1875 6.02872 8.1927 6.04301 8.20699C6.0573 8.22128 6.0625 8.23694 6.0625 8.25V13.5C6.0625 13.5131 6.0573 13.5287 6.04301 13.543C6.02872 13.5573 6.01306 13.5625 6 13.5625Z",
    fill: "black",
    stroke: "black",
    style: {
      fill: "black",
      fillOpacity: 1,
      stroke: "black",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 14.0625C8.6925 14.0625 8.4375 13.8075 8.4375 13.5V8.25C8.4375 7.9425 8.6925 7.6875 9 7.6875C9.3075 7.6875 9.5625 7.9425 9.5625 8.25V13.5C9.5625 13.8075 9.3075 14.0625 9 14.0625Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14.0625C11.6925 14.0625 11.4375 13.8075 11.4375 13.5V8.25C11.4375 7.9425 11.6925 7.6875 12 7.6875C12.3075 7.6875 12.5625 7.9425 12.5625 8.25V13.5C12.5625 13.8075 12.3075 14.0625 12 14.0625Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 14.0625C14.6925 14.0625 14.4375 13.8075 14.4375 13.5V8.25C14.4375 7.9425 14.6925 7.6875 15 7.6875C15.3075 7.6875 15.5625 7.9425 15.5625 8.25V13.5C15.5625 13.8075 15.3075 14.0625 15 14.0625Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 17.0625H0.75C0.4425 17.0625 0.1875 16.8075 0.1875 16.5C0.1875 16.1925 0.4425 15.9375 0.75 15.9375H17.25C17.5575 15.9375 17.8125 16.1925 17.8125 16.5C17.8125 16.8075 17.5575 17.0625 17.25 17.0625Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 6.9375C8.07 6.9375 7.3125 6.18 7.3125 5.25C7.3125 4.32 8.07 3.5625 9 3.5625C9.93 3.5625 10.6875 4.32 10.6875 5.25C10.6875 6.18 9.93 6.9375 9 6.9375ZM9 4.6875C8.6925 4.6875 8.4375 4.9425 8.4375 5.25C8.4375 5.5575 8.6925 5.8125 9 5.8125C9.3075 5.8125 9.5625 5.5575 9.5625 5.25C9.5625 4.9425 9.3075 4.6875 9 4.6875Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaasIconBlack);
export default __webpack_public_path__ + "static/media/baas-icon-black.5430b92d6d0dd53f82c725c9cc9c67a8.svg";
export { ForwardRef as ReactComponent };